import { Component, Input } from '@angular/core';

import { InternalRoutes } from '../../../data/internal-routes';
import { ButtonComponent } from '../../buttons/button.component';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'pin-menu-items',
    templateUrl: './menu-items.component.html',
    styleUrls: ['../menu.component.scss'],
    imports: [ButtonComponent, MatDivider, MatIcon]
})
export class MenuItemsComponent {
  @Input()
  isSsoUser = false;
  @Input()
  hasCustomerLevelAccess = false;
  @Input()
  closeMenu: () => void;

  internalRoutes = InternalRoutes;
}
